import { render, staticRenderFns } from "./topBar.vue?vue&type=template&id=c455d83e&scoped=true"
import script from "./topBar.vue?vue&type=script&lang=ts"
export * from "./topBar.vue?vue&type=script&lang=ts"
import style0 from "./topBar.vue?vue&type=style&index=0&id=c455d83e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_idpt5aadqkxzu6szyh7dhosqta/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c455d83e",
  null
  
)

export default component.exports